














































































































import Vue from 'vue';
import { mapGetters } from "vuex";
import {
  DEPOT_STORE,
  FETCH_PLACEDORDERS,
  PLACEDORDERS, PLACEDORDERS_LOADED, PLACEDORDERS_LOADING,
  PlacedOrdersFetchParameter
} from "@/common/store/modules/DepotStore";
import { PlacedOrderDto, OrderInstrumentDto, Side } from '@/common/types/PlacedOrderDto';
import OctInstrumentList from "@/components/Depot/OctInstrumentList.vue";

export default Vue.extend({
  name: 'OctPlacedOrderList',
  components: {
    OctInstrumentList
  },
  data() {
    return {
      localPlacedOrders: [],
      expanded: [],
      headers: [
        {
          text: this.$t('order_prop_status'),
          value: 'status'
        },
        {
          text: this.$t('order_prop_clientTimestamp'),
          value: 'transmissionDate'
        },
        {
          text: this.$t('order_prop_symbol'),
          value: 'symbol'
        },
        {
          text: this.$t('order_prop_longName'),
          value: 'name'
        },
        {
          text: this.$t('order_prop_marketPlace'),
          value: 'exchange'
        },
        {
          text: this.$t('order_prop_contractCount'),
          value: 'quantity'
        },
        {
          text: '',
          value: 'data-table-expand'
        }
      ]
    };
  },
  computed: {
    ...mapGetters(DEPOT_STORE, [PLACEDORDERS, PLACEDORDERS_LOADED, PLACEDORDERS_LOADING])
  },
  watch: {
    [PLACEDORDERS](newValue, oldValue) {
      if (this.PLACEDORDERS_LOADED) {
        this.localPlacedOrders = newValue.map((placedOrder: PlacedOrderDto) => {
          let flatPlacedOrder = {
            ...placedOrder
          };
          return flatPlacedOrder;
        });
      }
    }
  },
  methods: {
    mergeSymbolColumn(instrument: OrderInstrumentDto) {
      let result: string = instrument.symbol;
      if (instrument.isin) {
        result += ' (' + instrument.isin + ')';
      }

      return result;
    },
    getColor(status: string) {
      switch (status) {
      case "TRANSMITTED":
        return 'green';
      case "TRANSMITTED_WITH_STATUS_ERROR":
        return 'orange';
      default:
        return 'red';
      }
    },
    addSignToContractCount(quantity: number, side: Side) {
      if (side == 'Sell') {
        return '-' + quantity;
      }
      return quantity;
    },
    getIcon(status: string) {
      switch (status) {
      case "TRANSMITTED":
        return 'mdi-check-circle-outline';
      case "TRANSMITTED_WITH_STATUS_ERROR":
        return 'mdi-information-outline';
      default:
        return 'mdi-close-circle-outline';
      }
    }
  },
  mounted(): void {
    this.$store.dispatch(FETCH_PLACEDORDERS, { id: this.$route.params.id } as PlacedOrdersFetchParameter);
  }
});
